import Vue from "vue";
import {
  Col,
  Row,
  Swipe,
  SwipeItem,
  Lazyload,
  Tab,
  Tabs,
  Popup,
  List,
  Empty,
  DropdownMenu,
  DropdownItem,
Loading,
Sidebar,
SidebarItem,
Cell, CellGroup

} from "vant";

Vue.use(Col);
Vue.use(Row);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Popup);
Vue.use(List);
Vue.use(Empty);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Loading);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Cell);
Vue.use(CellGroup);
